var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('el-dialog', _vm._g(_vm._b({
    ref: "dialogRef",
    attrs: {
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('div', {
          staticClass: "header"
        }, [_vm.$slots.title ? [_vm._t("title")] : _c('div', {
          staticClass: "title"
        }, [_vm._v(_vm._s(_vm.title))]), _c('img', {
          staticClass: "close-icon",
          attrs: {
            "src": require("../../assets/dialog-close.png"),
            "alt": ""
          },
          on: {
            "click": _vm.close
          }
        })], 2)];
      },
      proxy: true
    }], null, true)
  }, 'el-dialog', _vm.$attrs, false), _vm.$listeners), [_vm.headerDivider ? _c('el-divider', {
    staticClass: "divider"
  }) : _vm._e(), _vm._t("default"), _c('template', {
    slot: "footer"
  }, [_vm.$slots.footer ? _c('el-divider', {
    staticClass: "divider"
  }) : _vm._e(), _c('div', {
    staticClass: "footer"
  }, [_vm._t("footer")], 2)], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };